import { Stream } from '@cgs/wge';

export const TRIFECTA_START_PAGE_COMPONENT_TOKEN = Symbol('TRIFECTA_START_PAGE_COMPONENT_TOKEN');

export class TrifectaStartPageComponent {
  public readonly onClose = new Stream<void>();
}
